import * as React from 'react';
import { Color, Display1Props, Display2, useTheme } from '@gousto-internal/citrus-react';

export function SectionHeading(props: Omit<Display1Props, 'size'>) {
  const { theme } = useTheme();
  const display3Size = theme.tokens.typographyDefaults.display3.size;

  const { color = Color.Primary_600, children, ...displayProps } = props;

  return (
    <Display2
      color={color}
      id="effortless-home-cooking-heading"
      size={display3Size}
      {...displayProps}
    >
      {children}
    </Display2>
  );
}
